module.exports = __webpack_public_path__ + "img/metal_r@2x.3a98ef38.png";